"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeNamespace = exports["default"] = void 0;
/**
 * Extracts a property from an object using the specified namespace key
 * @param {Object} object - The object containing the namespaced property
 * @param {string} namespace - The namespace key to extract
 * @returns The value at object[namespace] or undefined if namespace doesn't exist
 */
var removeNamespace = exports.removeNamespace = function removeNamespace(object, namespace) {
  return namespace && object && object[namespace];
};
var _default = exports["default"] = removeNamespace;